// const BASE_URL_API = "https://apisedap.teknologi40.online";
// const BASE_URL_API = "http://localhost:800";
// const MEMBER_URL = "http://localhost:4003";
// const PAYMENT_URL = "http://localhost:4004";
// const EVENT_URL = "http://localhost:4005";
const BASE_URL_API = "https://api.baituljihad.id";
// const MEMBER_URL = "https://member.iais.id";
// const PAYMENT_URL = "https://payment.iais.id";
// const EVENT_URL = "https://event.iais.id";
//const BASE_URL_API = "https://apiikatei.teknologi40.com"; //
// var BASE_URL_API = 'mongodb://dani:dani@103.151.191.89:27017/portaldadi1';
// const BASE_URL_API = "http://localhost:501"; //

// const BASE_URL_API = StaticVar.URL_API; //
export default {
  URL_API: BASE_URL_API,
  URL_REPO: `${BASE_URL_API}/media`,
  // URL_MEMBER: MEMBER_URL,
  // URL_PAYMENT: PAYMENT_URL,
  // URL_EVENT: EVENT_URL,
};
